/* eslint-disable prettier/prettier */
import { createContext, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";

const LanguageContext = createContext();


export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(() => {
        // 👇 read once on initial load
        return localStorage.getItem("lang") || "kn";
    });

    // 👇 save whenever language changes
    useEffect(() => {
        localStorage.setItem("lang", lang);
    }, [lang]);

    return (
        <LanguageContext.Provider value={{ lang, setLang }}>
            {children}
        </LanguageContext.Provider>
    );
};
LanguageProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export const useLanguage = () => useContext(LanguageContext);
